import { useRouter } from 'next/router'
import type { FC, MouseEventHandler, ReactElement } from 'react'

import ChevronLeftIcon from '~assets/icons/chevron-left.svg'

import * as Styled from './StepHeader.styled'
export interface StepHeaderProps {
  title?: string | ReactElement
  description?: string
  onBackClick?: MouseEventHandler<HTMLButtonElement>
  hideBackButton?: boolean
}

export const StepHeader: FC<StepHeaderProps> = ({
  title,
  description,
  onBackClick,
  hideBackButton,
}) => {
  const router = useRouter()

  const handleBackClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    if (onBackClick) return onBackClick(e)
    router.back()
  }

  return (
    <Styled.Container>
      <Styled.HeaderContainer hideBackButton={hideBackButton}>
        {!hideBackButton && (
          <Styled.BackButton onClick={handleBackClick}>
            <ChevronLeftIcon />
          </Styled.BackButton>
        )}
        <Styled.Title>{title}</Styled.Title>
      </Styled.HeaderContainer>
      <Styled.Description>{description}</Styled.Description>
    </Styled.Container>
  )
}
